module.exports = __webpack_public_path__ + "media/images/logo-68f741afea9863966cd3484ef70a6795.svg";